import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Login from "@/pages/Login";

export const Route = createFileRoute("/login")({
  head: () => seoHead({
    title: "Login Shopping do Bem | Acesse sua conta",
    description: "Acesse sua conta no Shopping do Bem para acompanhar suas compras, doações e impacto social.",
    path: "/login",
  }),
  component: Login,
});
